import { connect } from 'react-redux';
import { compose } from 'recompose';
import TouchIndicator from '../components/TouchIndicator';
import onlyIf from '../hocs/onlyIf';
function mapStateToProps(state) {
    return {
        showTouchIndicators: state.project.showTouchIndicators,
    };
}
export default compose(connect(mapStateToProps), onlyIf(function (props) { return props.showTouchIndicators; }))(TouchIndicator);
